// Use "require" syntax if you want your shit code here.
// Use "import" syntax if you want your awesome modules here.

import 'core-js/es6/promise';
import 'core-js/modules/es6.object.assign';
import 'whatwg-fetch';
import GdprManager from './gdpr/gdpr-manager';

import Locales from './modules/locales';
import WG from './modules/wg';
import merge from 'lodash.merge';
import LazyLoad from './modules/lazy-load';

require('../vendor/jquery-throttle-debounce.min');
require('../vendor/jquery.scrollTo.min');
require('../vendor/jquery.mask.min');
require('../vendor/fontfaceobserver');
require('../vendor/isMobile');

require('./modules/analytics');
require('./modules/promo-banner');
require('./modules/init-wg');
require('./modules/geo');
require('./modules/global');
require('./modules/language-banner');
require('./modules/cookie-banner');
require('./modules/exit-popup');
require('./modules/init-trial-exit-popup');
require('./modules/contact-sales');
require('./widgets/customer-stories-randomizer');

(function(global, WG, ContactSales) {
    let hasDeepLink = false;

    function initSignupForms() {
        var Registration = new WG.RegistrationNew();

        Registration.setOptions({
            locale: global.locale,
            forms: $('[data-signup-form]').add($('.wg-header__free-trial-form'))
        });
        Registration.init();
    }

    function initModals() {
        $(`.wg-header .action__open-in-modal.wg-header__free-trial-button`).on('click', function(event) {
            event.stopPropagation();
            event.preventDefault();
            $('.modal-form-trial.wg-modal--pro')
                .wgInstance()
                .show();
        });
    }

    function initContactSales() {
        const isInit = document.documentElement.lang !== 'ja';
        const modalId = 'modal-sales';
        const $modal = $(`#${modalId}`);
        const contactSales = new ContactSales({
            subType: 'homepageCallRequest',
            clientId: 'homepageCallRequest',
            $handler: $(`[data-show="${modalId}"]`),
            $form: $modal.find('form'),
            $successMessage: $modal.find('.modal-form-contact__success'),
            $closeHandler: $modal.find('.modal-form-contact__close'),
            classCloseColorInvert: 'modal-form-contact__close--white',
            marketoId: 2005,
            marketoFormType: 'contact_sales',
            onOpen: function() {
                global.trackEventForm({
                    event: 'menu_form_click',
                    value: {
                        subtype: 'contactsalesmenu',
                        content: 'regular_contact'
                    }
                });
            },
            onSuccess: function(sales) {
                const trackingSubType = 'contact_sales';
                const trackingForm = hasDeepLink ? 'popup' : 'menu_form';
                const formData = sales.formData;
                const defaultData = {
                    value: {
                        type: 'contact',
                        subtype: trackingSubType,
                        form: trackingForm,
                        content: 'regular_contact',
                        email: formData.email,
                        name: formData.name,
                        phone_number: `${formData['code']} ${formData['phone']}`,
                        description: formData.question,
                        job_title: formData.job_role,
                        job_role: formData.job_level
                    }
                };

                const statSiteData = {
                    event: 'contact_sales_form__submit'
                };

                const airPrData = {
                    event: 'non_trial_form__submitted',
                    value: {
                        event: 'contact_sales_form__submitted'
                    }
                };

                global.trackEventForm(merge(defaultData, statSiteData), false);
                new WG.AirPrTracking(merge(defaultData, airPrData));
            }
        });

        if (isInit) {
            contactSales.init();
        }
    }

    function initAffiliateOrPartnerCookie() {
        var codeRegex = /[^\w]/g;

        var partnerCode = global.getGETParameterByName('r').replace(codeRegex, '');
        var saleCode = global.getGETParameterByName('sales').replace(codeRegex, '');

        if (partnerCode.length) {
            WG.utils.setCookie('partner_referral_code', partnerCode, {
                expires: global.getDatePlus31(),
                path: '/'
            });
        }

        if (saleCode.length) {
            WG.utils.setCookie('sales_referrer_name', saleCode, {
                expires: global.getDatePlus31(),
                path: '/'
            });
        }
    }

    function initModalHashOpening() {
        var hash = location.hash.replace(/^#/, '');
        var modal;

        if (hash) {
            modal = $('.wg-modal')
                .filter('[data-hash="' + hash + '"]')
                .eq(0);

            if (modal.length) {
                modal.on('ready.wg.modal', function() {
                    $(this)
                        .wgInstance()
                        .show();
                });
            }
        }
    }

    function initAutofocus() {
        $('.wg-modal')
            .not('.wg-modal--no-autofocus')
            .on('show.wg.modal', function() {
                setTimeout(
                    function(modal) {
                        $(modal)
                            .find('.wg-input, .wg-select')
                            .not('.wg-input--invalid,.wg-select--invalid')
                            .eq(0)
                            .trigger('focus');
                    },
                    1,
                    this
                );
            });
    }

    function setPhoneNumber() {
        const lang = document.documentElement.lang;
        const $phone = $('.js-header-phone');
        const phones = window.headerPhones;
        const userCountryCode = window.geo.getCountryCode();
        const isEurope = Locales.checkEurope(userCountryCode);
        let phone = '';

        switch (lang) {
            case 'de':
                phone = phones['de'];
                break;
            case 'fr':
                phone = phones['fr'];
                break;
            case 'pt-br':
                phone = isEurope ? phones['pt'] : phones['br'];
                break;
            case 'ru':
                phone = phones['ru'];
                break;
            case 'it':
                phone = phones['it'];
                break;
            case 'ja':
                phone = phones['ja'];
                break;
            case 'en':
                phone = isEurope ? phones['en']['europe'] : phones['en']['na'];
                break;
            case 'es':
                phone = isEurope ? phones['es']['europe'] : phones['es']['other'];
                break;
            default:
                return;
        }

        $phone.text(phone);
        $phone.attr('href', 'tel:' + phone);
    }

    function initPhoneFormatter() {
        const domNodes = [].slice.call(document.querySelectorAll('[type = "tel"]'));

        if (domNodes.length < 1) return;

        import(/* webpackChunkName: "phone-formatter" */ './modules/phone-formatter');
    }

    function initCommonWidgets() {
        new global.CustomerStoriesRandomizer();
    }

    function initGdpr() {
        const gdprManager = new GdprManager();
        gdprManager.init();
    }

    function initDeepLink() {
        const utmContent = global.getGETParameterByName('utm_content');
        const form = global.getGETParameterByName('form');
        const $modal = $('#modal-sales');

        if (utmContent === 'Contact Us' || form === 'true') {
            hasDeepLink = true;

            $modal.wgInstance().show();

            $modal.on('hide.wg.modal', () => {
                hasDeepLink = false;
            });
        }
    }

    function initAirPrTracking() {
        const $trialFormIntro = $('.section-intro .wg-form');
        const $trialInputIntro = $('.section-intro .wg-input');

        $trialFormIntro.on('success.wg.registration', () => {
            const plan = $(this).data('plan');
            const packages = $(this).data('packages');
            const addons = $(this).data('addons');
            const onboarding = $(this).data('onboarding');

            const defaultData = {
                value: {
                    email: $trialInputIntro.val(),
                    form: $trialFormIntro.data('hash'),
                    plan: plan || 'BIZ_2021',
                    packages,
                    addons,
                    onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            const statSiteData = {
                group: 'trial_forms',
                event: 'trial_form__submit',
                path: window.location.pathname
            };

            const airPrData = {
                event: 'trial_form__submitted'
            };

            global.trackEventForm(merge(defaultData, statSiteData));
            new WG.AirPrTracking(merge(defaultData, airPrData));
        });

        $trialFormIntro.on('user.exist.wg.success.registration', () => {
            const plan = $(this).data('plan');
            const packages = $(this).data('packages');
            const addons = $(this).data('addons');
            const onboarding = $(this).data('onboarding');

            const defaultData = {
                value: {
                    email: $trialInputIntro.val(),
                    form: $trialFormIntro.data('hash'),
                    plan: plan || 'BIZ_2021',
                    packages,
                    addons,
                    onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            const statSiteDataForExistedUser = {
                group: 'exist_user_form_submit',
                event: 'exist_trial_form__submit',
                path: window.location.pathname
            };

            const airPrDataForExistedUser = {
                event: 'exist_trial_form__submitted'
            };

            global.trackEventForm(merge(defaultData, statSiteDataForExistedUser));
            new WG.AirPrTracking(merge(defaultData, airPrDataForExistedUser));
        });

        const $trialFormOutro = $('.section-common-outro .wg-form');
        const $trialInputOutro = $('.section-common-outro .wg-input');

        $trialFormOutro.on('success.wg.registration', () => {
            const plan = $(this).data('plan');
            const packages = $(this).data('packages');
            const addons = $(this).data('addons');
            const onboarding = $(this).data('onboarding');

            const defaultData = {
                value: {
                    email: $trialInputOutro.val(),
                    form: $trialFormOutro.data('hash'),
                    plan,
                    packages,
                    addons,
                    onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            const statSiteData = {
                group: 'trial_forms',
                event: 'trial_form__submit',
                path: window.location.pathname
            };

            const airPrData = {
                event: 'trial_form__submitted'
            };

            global.trackEventForm(merge(defaultData, statSiteData));
            new WG.AirPrTracking(merge(defaultData, airPrData));
        });

        $trialFormOutro.on('user.exist.wg.success.registration', () => {
            const plan = $(this).data('plan');
            const packages = $(this).data('packages');
            const addons = $(this).data('addons');
            const onboarding = $(this).data('onboarding');

            const defaultData = {
                value: {
                    email: $trialInputOutro.val(),
                    form: $trialFormOutro.data('hash'),
                    plan,
                    packages,
                    addons,
                    onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            const statSiteDataForExistedUser = {
                group: 'exist_user_form_submit',
                event: 'exist_trial_form__submit',
                path: window.location.pathname
            };

            const airPrDataForExistedUser = {
                event: 'exist_trial_form__submitted'
            };

            global.trackEventForm(merge(defaultData, statSiteDataForExistedUser));
            new WG.AirPrTracking(merge(defaultData, airPrDataForExistedUser));
        });
    }

    function changeLoginLink() {
        let allowedHosts = ['www.wrike.com', 'alpha.wrke.io', 'rc.wrke.io', 'rctests.wrke.io', 'trtests.wrke.io'],
            currentHost = window.location.host;

        if (!allowedHosts.includes(currentHost)) {
            let links = Array.from(document.getElementsByClassName('wg-header__login-button')),
                anotherLinks = Array.from(document.getElementsByClassName('home-intro-login-button'));

            links = links.concat(anotherLinks);

            for (let i = 0; i < links.length; i++) {
                let link = links[i],
                    envPosition = -1;

                for (let j = 0; j < allowedHosts.length; j++) {
                    envPosition = currentHost.search(allowedHosts[j]);

                    if (envPosition !== -1) {
                        if (currentHost.slice(0, envPosition) === 'read-') {
                            link.href = ['https://login-', currentHost.slice(envPosition), '/login/?read'].join('');
                        } else {
                            link.href = [
                                'https://',
                                currentHost.slice(0, envPosition),
                                'login-',
                                currentHost.slice(envPosition),
                                '/login/'
                            ].join('');
                        }
                        break;
                    }
                }
            }
        }
    }

    function main() {
        window.requestAnimationFrame =
            window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;

        LazyLoad.initImg();

        changeLoginLink();
        initSignupForms();
        initModals();
        initModalHashOpening();
        initDeepLink();
        initContactSales();
        initAutofocus();
        initAffiliateOrPartnerCookie();
        setPhoneNumber();
        initPhoneFormatter();
        initCommonWidgets();
        initGdpr();
        initAirPrTracking();
    }

    $(main);
})(window.wrike, window.WG, window.ContactSales);



// WEBPACK FOOTER //
// ./assets/js/common/common.js